import { colors } from "/constants"
import locales, { localeOptions } from "constants/locales"
import { changeLocale } from "utils/commonUtils"
import Divider from "../components/layouts/divider"
import assetPrefix from "../utils/assetPrefix"
import str from "../utils/strings"
import { BottomLine, Container, FixedWrapepr, LangContainer, LangLabel, Root, TDCLogoAContainer } from "./header.styles"

const Header = () => {
  const handleChangeLocale = (key) => {
    if (!(key in locales)) return
    changeLocale(key)
  }

  return (
    <Root>
      <FixedWrapepr>
        <Container>
          <TDCLogoAContainer href={str.TXT_LANDING_Logo_Link_Url} target="_blank" aria-label={str.TXT_ONLINE_FORM_Aria_Label_Header_Logo}>
            <img src={`${assetPrefix}/images/logo-header.svg`} alt="TDC Logo" height="100%" />
          </TDCLogoAContainer>
          <LangContainer>
            {localeOptions
              .filter((locale) => str.locale !== locale.value)
              .map((locale) => (
                <LangLabel key={locale.value} onClick={() => handleChangeLocale(locale.value)}>
                  {locale.shortName}
                </LangLabel>
              ))}
          </LangContainer>
        </Container>
        <Divider color={colors.blood_orange} />
        <BottomLine />
      </FixedWrapepr>
    </Root>
  )
}

export default Header
